<template>
    <div
        :class="[
            'flex flex-col',
            labelSide !== 'top' ? 'lg:flex-row lg:items-center' : '',
        ]"
    >
        <div v-if="label" class="pr-3 pb-1 lg:pb-0 min-w-[120px]">
            <span
                class="text-[11px] font-bold text-primary uppercase tracking-wider opacity-60"
            >
                {{ label }}
            </span>
        </div>
        <div class="flex items-center">
            <input-switch
                v-bind="getInputProps({})"
                color="primary"
                v-model="inputValue"
            >
                <template #hidden="{ checked }">
                    <input
                        type="hidden"
                        :name="name"
                        :value="checked ? checkedValue : uncheckedValue"
                    />
                </template>
                <template #next="{ checked }">
                    <span
                        class="ml-4 text-[11px] font-bold text-primary uppercase tracking-wider"
                    >
                        {{ checked ? checkedLabel : uncheckedLabel }}
                    </span>
                </template>
            </input-switch>
        </div>
    </div>
</template>

<script>
import mixinCommon from "./mixinCommon.vue";
import mixinInput from "./mixinInput.vue";
import InputSwitch from "./InputSwitch.vue";

export default {
    mixins: [mixinCommon, mixinInput],
    components: {
        "input-switch": InputSwitch,
    },
    props: {
        ...InputSwitch.props,
        name: { type: String, default: "" },
        label: { type: String, default: "" },
        labelSide: { type: String, default: "left" },
        checkedLabel: { type: String, default: "yes" },
        uncheckedLabel: { type: String, default: "no" },
        checkedValue: { type: [String, Number], default: 1 },
        uncheckedValue: { type: [String, Number], default: 0 },
    },
    methods: {
        getInputProps(overrideProps = {}) {
            return this.getComponentProps(InputSwitch, overrideProps);
        },
    },
};
</script>
